const countryCurrencies = {
  AU: 'A$',
  AT: '€',
  BE: '€',
  CA: 'C$',
  CZ: 'Kč',
  DK: 'kr',
  FI: '€',
  FR: '€',
  DE: '€',
  HK: 'HK$',
  IN: '₹',
  IE: '€',
  IL: '₪',
  IT: '€',
  JP: '¥',
  MY: 'RM',
  NL: '€',
  NZ: 'NZ$',
  NO: 'kr',
  PL: 'zł',
  PT: '€',
  SG: 'S$',
  KR: '₩',
  ES: '€',
  SE: 'kr',
  CH: 'CHF',
  AE: 'د.إ',
  GB: '£',
  US: '$'
};

// Function to update currency symbols
function updateCurrencySymbols() {
  document.querySelectorAll('.js-country-switcher-country-item-link').forEach(link => {
    const countryCode = link.getAttribute('data-value');
    const currency = countryCurrencies[countryCode] || '€';
    link.innerHTML = link.innerHTML.replace(/\([^\)]*\)/, `(${currency})`);
  });
}

// Observe the dropdown container
const dropdown = document.querySelector('#CountrySwitcherCountryList-016879882b50d2caceeb4');
if (dropdown) {
  const observer = new MutationObserver(updateCurrencySymbols);
  observer.observe(dropdown, { childList: true, subtree: true });
}

// Also run once on page load
updateCurrencySymbols();
